import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogConfig,} from '@angular/material';
import {tap, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import {merge, fromEvent} from "rxjs";

import { User } from '@app/_models/user';
import { Reserva } from '@app/_models/reserva';
import { Facility } from '@app/_models/facilities';
import { ReservasService } from '@app/services/reservas.service';
import { ReservasDataSource } from '@app/services/reservas.datasource';
import { ReservaDialogComponent } from '../reserva-dialog/reserva-dialog.component';
import { SessionService } from '@app/services/session.service';
import { ReservaModalComponent } from '@app/components/reserva-modal/reserva-modal.component';
import { AuthenticationService } from '@app/services/authentication.service';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';

const moment = _rollupMoment || _moment;


@Component({
  selector: 'app-mod-reservas-list',
  templateUrl: './mod-reservas-list.component.html',
  styleUrls: ['./mod-reservas-list.component.scss']
})
export class ModReservasListComponent implements OnInit, AfterViewInit {
  @Output() reservaModified: EventEmitter<boolean> = new EventEmitter<boolean>();

  currentDay: Date;
  currentDateSelector = new FormControl(moment());
  currentUser: User;
  access_type: string;
  private facility: Facility;
  private refresh: boolean = false;
  btnReservaDisabled: boolean;
  displayedColumns: string[] = ['date', 'status', 'planner', 'cancha', 'jugadores', 'more'];
  dataSource: ReservasDataSource;
  fStatus: string = '';
  fText: string = '';


  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('searchInput', { static: false }) input: ElementRef;

  constructor(
    private authService: AuthenticationService,
    private reservasService: ReservasService,
    private session: SessionService,
    public modalReserva: MatDialog,
    public dialog: MatDialog,

  ) { }

  ngOnInit() {
    this.currentUser = this.authService.currentUserValue;
    this.facility = this.session.currentFacility;
    this.access_type = this.session.accessType('reservas');
    this.dataSource = new ReservasDataSource(this.reservasService);
    this.dataSource.loadReservas(1, '-start_time', '', '', 0, 10);
    this.resultsLength = this.dataSource.total;
  }



  
  ngAfterViewInit() {
    this.resultsLength = this.dataSource.total;
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    
    fromEvent(this.input.nativeElement,'keyup')
        .pipe(
            debounceTime(250),
            distinctUntilChanged(),
            tap(() => {
                this.paginator.pageIndex = 0;
                this.loadReservasPage();
            })
        )
        .subscribe();
   
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        tap(() => this.loadReservasPage())
    )
    .subscribe();
  }

  newReserva() {
    const config = new MatDialogConfig();
    config.data = {
      reserva: new Reserva(),
      day: this.currentDay
    }
    config.width = '600px';
    const modal = this.modalReserva.open(ReservaModalComponent, config);

    modal.afterClosed().subscribe((data: any) => {
      if (data) { // Si recibe data, es la fecha de la reserva que se creo
        this.currentDay = data;
        this.Refresh()
      }
    })

  }

  public Refresh() {
    // Agrega un minuto para que se refresque
    var sec = this.currentDay.getSeconds();
    this.currentDay.setMinutes(sec + 1);
  }

  loadReservasPage() {
      let vSort = this.sort.active;
      if (this.sort.direction == 'desc') {
        vSort = '-' + vSort;
      }
      this.dataSource.loadReservas(
        1,
        vSort,
        this.fStatus,
        this.input.nativeElement.value,
        this.paginator.pageIndex,
        this.paginator.pageSize,
      );
  }

  filterStatus() {
    this.loadReservasPage();
  }

  openReserva(p_reserva: Reserva): void {
    const config = new MatDialogConfig();
    config.data = {
      reserva: p_reserva
    }
    config.width = '600px';
    const dialogRef = this.dialog.open(ReservaDialogComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      this.reservaModified.emit(true);
    });
  }

}
